// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"e1ab5671fe9d69a41e55","655":"f89dddb9f2e76e2d314e"}[chunkId] + ".js";
};